"use strict";
// Copyright (c) 2023 mr-luke
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowType = exports.StreamBusType = exports.ModalType = exports.DocumentType = exports.DateTimeType = void 0;
exports.DateTimeType = Symbol.for('IDateTime');
exports.DocumentType = Symbol.for('IDocument');
exports.ModalType = Symbol.for('IModal');
exports.StreamBusType = Symbol.for('IStreamBus');
exports.WindowType = Symbol.for('IWindow');
